import MainTitle from '../common/MainTitle';
import Icon from '../common/Icon';
import VideoSchema from '../common/VideoSchema';
import ImageLink from '../../js/utils/ImageLink';
import { getYouTubeEmbedUrl, isMp4Url } from '../../js/utils/video-url';

export default function EducationalProgram({ data }) {
  const youtubeEmbed = getYouTubeEmbedUrl(data?.videoLink);
  const mediaUrl = data?.media?.url;
  const mediaIsVideo = isMp4Url(mediaUrl);
  const videoLinkIsMp4 = isMp4Url(data?.videoLink);

  const videoUrl = youtubeEmbed
    ? data?.videoLink
    : mediaIsVideo
      ? ImageLink(mediaUrl)
      : videoLinkIsMp4
        ? data?.videoLink
        : null;
  const videoTitle =
    [data?.title1, data?.title2].filter(Boolean).join(' ') ||
    'Educational Program at Manara School';

  return (
    <section className="educational-program">
      {videoUrl && (
        <VideoSchema
          name={videoTitle}
          description={data?.media?.alt || 'Educational Program at Manara School'}
          contentUrl={videoUrl}
          thumbnailUrl={mediaUrl ? ImageLink(mediaUrl) : videoUrl}
        />
      )}
      <div className="container">
        <div className="educational-program__title">
          <MainTitle type="dark" className="text--2xl">
            <span>{data?.title1}</span>
            <span className="decorated-line decorated-line--dark decorated-line--left">
              {data?.title2}
            </span>
          </MainTitle>
        </div>

        <Icon name="spiral-arrow" className="spiral-arrow-icon" />
      </div>
      <div className="educational-program__content">
        {youtubeEmbed && (
          <iframe
            width="100%"
            height="500"
            src={youtubeEmbed}
            title={data?.title1 || 'Video'}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        )}
        {!youtubeEmbed && mediaIsVideo && (
          <video width="100%" controls src={ImageLink(mediaUrl)} />
        )}
        {!youtubeEmbed && !mediaIsVideo && videoLinkIsMp4 && (
          <video width="100%" controls src={data?.videoLink} />
        )}
        {!youtubeEmbed && !mediaIsVideo && !videoLinkIsMp4 && mediaUrl && (
          <>
            <div className="overlay" />
            <img src={ImageLink(mediaUrl)} alt={data?.media?.alt} />
          </>
        )}
      </div>
    </section>
  );
}
